import Button from "Components/Common/Button/Button";
import { formatCurrency } from "../constants/sovSetupData";

interface SovRow {
  id: string | number;
}

interface Lender {
  companyName?: string;
}

interface SuccessScreenProps {
  rows: SovRow[];
  divisionsCount: number;
  total: number;
  lender?: Lender;
  onBack: () => void;
  onDownload: () => void;
}

export default function SuccessScreen({
  rows,
  divisionsCount,
  total,
  lender,
  onBack,
  onDownload,
}: SuccessScreenProps) {
  const bankName = lender?.companyName || "Bank";
  const checklist = [
    `${rows.length} line item${rows.length !== 1 ? "s" : ""} across ${divisionsCount} CSI division${divisionsCount !== 1 ? "s" : ""}`,
    `Total SOV: ${formatCurrency(total)} — matches contract ✓`,
    "System Admin notified for review",
    `${bankName} notified for review`,
    "SOV PDF attached to project record",
  ];

  return (
    <div className="sovSuccessWrap">
      <div className="sovSuccessIcon">📋</div>
      <h3 className="sovSuccessTitle">Schedule of Values Submitted</h3>
      <p className="sovSuccessSub">
        Your Schedule of Values has been submitted to CSC New England for
        review. Once reviewed and approved by CSC and {bankName}, the SOV will
        be locked and you will be authorized to submit your first draw request.
      </p>

      <div className="sovSuccessCard">
        <p className="sovSuccessCardTitle">Submitted</p>
        <div className="sovSuccessList">
          {checklist.map((item) => (
            <div key={item}>✓ {item}</div>
          ))}
        </div>
      </div>

      <div className="sovNextSteps">
        <strong>Next steps:</strong> CSC will review the SOV against your
        pre-construction documents and budget analysis. {bankName} has final
        approval. Typical review time: 2–5 business days. You'll be notified by
        email and in-app when approved.
      </div>

      <div className="sovSuccessActions">
        <Button type="button" className="btn primary" onClick={onBack}>
          ← Review SOV
        </Button>
        <Button type="button" className="btn secondary" onClick={onDownload}>
          Download SOV PDF
        </Button>
      </div>
    </div>
  );
}
